import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

export const getUsers = async (currentPage, itemsPerPage, filters = {}) => {
    try {
        const response = await axios.get(`${apiUrl}/user/all`, {
            params: {
                page: currentPage,
                limit: itemsPerPage,
                ...filters,
            },
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error al obtener los usuarios: ', error);
        throw error; // Propaga el error para manejarlo en el componente
    }
};

export const getUser = async (userId) => {
    try {
        const response = await axios.get(`${apiUrl}/user/${userId}`, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response.data;
    } catch (error) {
        console.error(`Error al obtener el usuario id ${userId}: `, error);
        throw error; // Propaga el error para manejarlo en el componente
    }
};

export const addUser = async (body) => {
    try {
        const response = await axios.post(`${apiUrl}/user/create`, body, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error al crear el usuario: ", error);
        throw error; // Propaga el error para manejarlo en el componente
    }
}

export const editUser = async (userId, body) => {
    try {
        const response = await axios.put(`${apiUrl}/user/${userId}`, body, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response.data;
    } catch (error) {
        console.error(`Error al actualizar el usuario id ${userId}: `, error);
        throw error; // Propaga el error para manejarlo en el componente
    }
}

export const deleteUser = async (userId) => {
    try {
        const response = await axios.delete(`${apiUrl}/user/${userId}`, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response;
    } catch (error) {
        console.error(`Error al eliminar el usuario id ${userId}: `, error);
        throw error; // Propaga el error para manejarlo en el componente
    }
}


export const getUserWithAuthorities = async () => {
    const token = localStorage.getItem("user-jwt");
    if (!token) return null;

    try {
        const response = await axios.get(`${apiUrl}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
        });

        return response.data; // Devuelve id, email, roles, permisos
    } catch (error) {
        console.error("Error obteniendo usuario:", error);
        return null;
    }
};